import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    SearchLinkStateInterface,
    SearchLinkFormInterface,
    ResponseSearchLinkInterface
} from '../../domain';

const initialState: SearchLinkStateInterface = {
    formData: {
        value: ''
    },
    loading: false,
    error: false,
    success: false,
    responseSearchLink: {
        message: '',
        success: false,
        link: ''
    }
};

const SearchLinkSlice = createSlice({
    name: 'searchlink',
    initialState,
    reducers: {
        setFormDataReducer: (state, action: PayloadAction<Partial<SearchLinkFormInterface>>) => {
            state.formData = { ...state.formData, ...action.payload };
        },
        submitRegistrationStartReducer: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        },
        submitRegistrationSuccessReducer: (state, action: PayloadAction<ResponseSearchLinkInterface>) => {
            state.loading = false;
            state.success = true;
            state.error = null;
            state.formData = initialState.formData;
            state.responseSearchLink = action.payload;
        },
        submitRegistrationFailureReducer: (state) => {
            state.loading = false;
            state.error = true;
            state.success = false;
        },
        clearRegistrationErrorReducer: (state) => {
            state.error = null;
            state.success = false;
        },
        resetRegistrationStateReducer: () => {
            return initialState
        }
    },
});

export const {
    setFormDataReducer,
    submitRegistrationStartReducer,
    submitRegistrationSuccessReducer,
    submitRegistrationFailureReducer,
    clearRegistrationErrorReducer,
    resetRegistrationStateReducer
} = SearchLinkSlice.actions;

export default SearchLinkSlice.reducer;
